import type { IUtils } from '@date-io/core/IUtils'
import * as React from 'react'

import type { MaterialUiPickersDate } from './typings/date'

export const MuiPickersContext = React.createContext<IUtils<MaterialUiPickersDate> | null>(null)

export interface MuiPickersUtilsProviderProps {
  utils: any
  children: React.ReactNode
  locale?: any
  libInstance?: any
}

export const MuiPickersUtilsProvider: React.FunctionComponent<MuiPickersUtilsProviderProps> = ({
  utils: Utils,
  children,
  locale,
  libInstance,
}) => {
  const utils = React.useMemo(() => new Utils({ locale, instance: libInstance }), [Utils, libInstance, locale])

  return <MuiPickersContext.Provider value={utils}>{children}</MuiPickersContext.Provider>
}
